
import { HDNode } from '@ethersproject/hdnode';
import { ethers, Wallet } from 'ethers';
import { Options, Vue } from 'vue-class-component';
import { $wallet } from '../services';

//
// btc specific
// https://forum.stacks.org/t/how-to-sign-data-with-app-private-key/6603

const bitcoin = require('../../bitcoinjs-lib');
const bitcoinMessage = require('bitcoinjs-message');

@Options({
  components: {
  },
})
export default class Wallets extends Vue {

  privateKey = "";
  rootMessage = "";
  wallet:HDNode|any= null;
  signedMessage:string|null = null;

  derivationOptions: any = {
    btc : {
      index: 0,
      path: "m/44'/0'/0'/0",
      b58:true
    },
    segwit : {
      index: 1,
      path: "m/84'/0'/0'/0",
      b58:true
    },
    eth : {
      index: 2,
      path: "m/44'/60'/0'/0",
      b58:false
    },
    monero : {
      index: 3,
      path: "m/44'/128'/0'/0",
      b58:true
    }
  };

  defaultDerivation = this.derivationOptions.btc;


  get isValidKey() {
    return $wallet.isValidPrivateKey(this.privateKey);
  }

  //
  // filter for address
  address(string: string) {
    return string;
  }

  async createWallet() {
    if(!this.isValidKey){
      return;
    }


    const network = (wallet:HDNode|Wallet) => {
      const privateKey = ethers.utils.arrayify(wallet.privateKey);
      const keyPair = bitcoin.ECPair.fromPrivateKey(Buffer.from(privateKey));    
      switch(this.defaultDerivation.index){
        case 0:// P2PK et P2PKH
        return { 
          btc:true,
          address:bitcoin.payments.p2pkh({ pubkey: keyPair.publicKey }).address,
          pubicKey:keyPair.publicKey.toString('hex'),
          compressed:keyPair.compressed,
          privateKey:keyPair.toWIF(),
          privateKeyBuffer: keyPair.privateKey
        };
        case 1:
        return { 
          btc:true,
          address:bitcoin.payments.p2wpkh({ pubkey: keyPair.publicKey }).address,
          pubicKey:keyPair.publicKey.toString('hex'),
          compressed:keyPair.compressed,
          privateKey:keyPair.toWIF(),
          privateKeyBuffer: keyPair.privateKey
        };
        default:
        return wallet;
      }
    };

    const hdnode= $wallet.createFromKey(this.privateKey);
    this.wallet = network(hdnode);
    return;
  }


  async updatePrivate($event:any) {
    try{
      //KzqNhjDJq7abHcJiqyCegQYoUh1e2Tyx24rHWd5NBLAheuFTJK4Z
      const keyPair = bitcoin.ECPair.fromWIF($event.target.value);
      this.privateKey = '0x'+keyPair.privateKey.toString('hex');
    }catch(err){
      this.privateKey = $event.target.value;
    }
  

    console.log(this.privateKey,this.privateKey.length)
    await this.createWallet();
  }


  async onDerivation(token: string) {
    this.defaultDerivation = this.derivationOptions[token] || this.derivationOptions.btc;
    this.createWallet();
  }

  async onSignMessage(){
    //FIXME, for BTC use lib https://github.com/bitcoinjs/bitcoinjs-message
    if(this.wallet.btc){
      this.signedMessage = bitcoinMessage.sign(this.rootMessage, this.wallet.privateKeyBuffer, this.wallet.compressed).toString('base64');
      //console.log('----DBG private key',this.wallet.privateKeyBuffer.toString('base64'))
    }else{
      this.signedMessage = await this.wallet.signMessage(this.rootMessage);
    }
  }
}
